import * as React from "react"
import injectSheet from "react-jss"
import { NavigationHeader } from "@/components/NavigationHeader"
import { NavigationSidebar } from "@/components/NavigationSidebar"

const styles = {
  container: {
    composes: "flex",
    height: "calc(100vh - 48px)",
  },
  main: { composes: "flex flex-auto flex-column" },
}

export default Component =>
  injectSheet(styles)(({ classes, ...props }) => (
    <React.Fragment>
      <NavigationHeader />
      <div className={classes.container}>
        <NavigationSidebar />
        <div className={classes.main}>
          <Component {...props} />
        </div>
      </div>
    </React.Fragment>
  ))
